// デモ（TOPページ埋め込み）の計測。GTM の dataLayer にカスタムイベントを積む。
// どのイベントをコンバージョンにするかは GTM 側のタグ・トリガーで設定する。
// イベント一覧（GTM のトリガーと対応）
// demo_try_click / demo_input_start / demo_pdf_confirm /
// demo_register_modal_close / demo_signup_start / demo_signup_complete
export const trackDemoEvent = (event, params = {}) => {
  // 計測に失敗しても本来の操作は止めない
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ...params, event });
  } catch {
    // 何もしない
  }
};
